import messages from "../../../locale/messages";

const validate = values => {

    const errors = {};

    if (!values?.phoneNumber || isNaN(values?.phoneNumber) || values?.phoneNumber.trim() === "") {
        errors.phoneNumber = messages.mobileNumberRequired;
    }

    return errors;
}

export default validate;